import React, { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRelayEnvironment } from 'react-relay/hooks'
import { useAuth } from 'hooks'
import fetchOrgBySlug from 'queries/fetchOrgBySlug'
import PageBodyLoading from 'components/app/PageBodyLoading'
import { NotFoundPage } from 'pages'

export default function RequireOrg({ children }) {
  const environment = useRelayEnvironment()
  const { orgSlug } = useParams()
  const { isReady, isLoggedIn, currentOrg, setCurrentOrg } = useAuth()
  const [invalidOrg, setInvalidOrg] = useState(false)

  useEffect(() => {
    const updateOrg = async () => {
      const org = await fetchOrgBySlug(environment, orgSlug)

      if (!org) {
        setInvalidOrg(true)
        return
      }

      setInvalidOrg(false)
      setCurrentOrg(org)
    }

    if (isReady && isLoggedIn && orgSlug) {
      updateOrg()
    }
  }, [setCurrentOrg, environment, orgSlug, isReady, isLoggedIn])

  if (invalidOrg) {
    return <NotFoundPage errorMessage="We couldn't find that firm." />
  }

  if (!currentOrg) {
    return <PageBodyLoading />
  }

  return children
}
